import { useEffect, useState } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

export default function LatexRender({ math, inline = true }) {
  const [html, setHtml] = useState("");

  useEffect(() => {
    try {
      const rendered = katex.renderToString(math, {
        throwOnError: false,
        displayMode: !inline,
      });
      setHtml(rendered);
    } catch (error) {
      setHtml("⚠️");
    }
  }, [math, inline]);

  return (
    <span
      className={inline ? "inline align-middle" : "block my-4 text-center"}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}